export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";